import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLoaderData } from "react-router-dom";

import Animation from "@areas/shared/components/chooseLayout/Animation";
import animationStyles from "@areas/shared/components/chooseLayout/styles/animations.module.css";

import { metaActions } from "@store";

import About from "./blocks/About";
import Map from "./blocks/Map/Map";
import Categories from "./blocks/Categories";
import Action from "./blocks/Action";
import News from "./blocks/News";
import Calendar from "./blocks/Calendar";
import Docs from "./blocks/Docs";
import Partners from "./blocks/Partners";
import ProgressRoad from "../../components/stepwalker/ProgressRoad";
import FTYandexMap from "../../components/stepwalker/FTYandexMap";
function Page(props) {
  const data = useLoaderData();
  const dispatch = useDispatch();
 const apiKey = "7e9247c8-4c61-409a-91c5-c49872daf93e"
  useEffect(() => {
    dispatch(
      metaActions.setData({
        icon: "/faviconSchoolboy.ico",
        title: "Школьники",
        description:
          "Школьники и будущие абитуриенты могут пройти профориентацию, с легкостью выбрать специальность и учебное заведение в Республике Башкортостан",
      })
    );
  }, [dispatch]);

  return (
    <div>
      <Animation
        animationIn={animationStyles.swipeLeftIn}
        animationOut={animationStyles.swipeRightOut}
      >
        <About />
      </Animation>
      <Animation>
        <ProgressRoad />
      </Animation>
     <Animation>
      <FTYandexMap apiKey={apiKey}> 
     </FTYandexMap>    
     </Animation>
      <Animation>
        <News data={data.Pages} />
      </Animation>
      <Animation>
        <Calendar data={data.Events} />
      </Animation>
      <Animation>
        <Docs />
      </Animation>
      <Animation>
        <Partners />
      </Animation>
    </div>
  );
}

export default Page;
